<section>
  <div >
    <p class="mb-10"  [innerHTML]="'$evaluation_ergo_recommendations_summary_introduction' | translate"></p>
  </div>
  <ng-container *ngIf="!readOnly && recommendationsAvailable">
    <button  mat-flat-button [matMenuTriggerFor]="categoryMenu"
      [innerHTML]="'$evaluation_ergo_recomm_add' | translate"></button>
    <mat-menu #categoryMenu="matMenu">
      <ng-container *ngFor="let category of recommendationCategories">
        <button  mat-menu-item [matMenuTriggerFor]="itemMenu">{{getCategoryname(category.categoryMullang)}}</button>
        <mat-menu #itemMenu="matMenu">
          <button *ngFor="let item of category.recommendations" mat-menu-item
            (click)="addRecommendationItem(item,category)">{{getItemTitle(item.recommendationItemsMullang)}}</button>
        </mat-menu>
      </ng-container>
    </mat-menu>
  </ng-container>

  <div class="recommendations">
    <h5 class="title" [innerHTML]="'$evaluation_ergo_recommendations_recommendation_title' | translate"></h5>
    <p *ngIf="!(recommendations$ | async) || (recommendations$ | async).length === 0" class="no-recommendations"
      [innerHTML]="'$evaluation_ergo_recommendations_no_recommendations' | translate"></p>
    <section *ngIf="recommendations$ | async" class="ergo-recommendations-accordion">
      <cz-edit-evaluation-recommendation *ngFor="let item of (recommendations$ | async); let i = index" [open]="i === 0"
        [saved$]="saved$" [item]="item" [currentUser]="currentUser" [readOnly]="readOnly"
        [cultureCookie]="cultureCookie" [backupLanguageId]="backupLanguageId"
        [recommendationsMultiLanguage]="item.recommendationMullang" [form]="form"
        (updateRecommendation)="forwardRecommendationUpdated($event)"
        (recommendationRemoved)="forwardRecommendationRemoved($event)"></cz-edit-evaluation-recommendation>
    </section>
  </div>
</section>